import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

import { bGId } from "common/constants/constants";
import Loader from "components/common/loader/Loader";
import SwiperSteps from "components/common/swiper/SwiperSteps";
import { Form, Formik } from "formik";
import { formatPermissions, handleClaimsParentLevel } from "utils/Utils";
import * as Yup from "yup";

import {
  UpdateUserById,
  getAllowedUsers,
  getUserById,
  getUserPermissions,
} from "services/UserManagementServices";
import { getConsultantUsers } from "services/UserManagementServices";
import { getAllBankslist } from "services/bankServices";
import { getBranchNames } from "services/branchServices";
import { getBranchProducts } from "services/branchServices";

import ClaimsInfo from "./ClaimsInfo";
import GeneralInfo from "./GeneralInfo";
import RoleInfo from "./RoleInfo";

import "components/common/parentButton/parentbtn.scss";
import { useTranslation } from "react-i18next";
const EditUser = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id: userIdParam } = useParams();
  const [showForm, setShowForm] = useState(false);

  const [currentTab, setCurrentTab] = useState(1);
  const [swiperSteps, setSwiperSteps] = useState([
    {
      id: 1,
      name: t("branch-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 2,
      name: t("user-details"),
      isError: false,
      isCompleted: false,
    },
    {
      id: 3,
      name: t("permissions"),
      isError: false,
      isCompleted: false,
    },
  ]);
  const [rolesList, setRolesList] = useState([]);
  const [permissionsList, setPermissionsList] = useState([]);
  const [permissionsListBackup, setPermissionsListBackup] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [bankId, setBankId] = useState("");
  const [branchId, setBranchId] = useState("");
  const [branchNameList, setBranchNameList] = useState([]);
  const [consultantList, setConsultantList] = useState([]);
  const [branchProducts, setBranchProducts] = useState([]);

  const [bankGroupId, setBankGroupId] = useState(bGId);
  const [userDetails, setUserDetails] = useState({});
  const [initialValues, setInitialValues] = useState({
    email: "",
    firstName: "",
    lastName: "",
    roleId: "",
    bankGroupId: "",
    bankId: "",
    branchId: "",
    consultantId: "",
    isActive: false,
    branchInfo: { branchId: "", bankId: "", bankGroupId: "" },
    claims: [],
    gender: "",
    consultantHelperName: "",
  });
  const bankGroupList = [{ value: bGId, label: "Genossenschaftsbanken" }];

  const validate = Yup.object({
    firstName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    lastName: Yup.string()
      .required(t("required"))
      .max(20, t("max-name-char-limit")),
    email: Yup.string().required(t("required")).email(t("email-error")),
    roleId: Yup.string().required(t("required")),
    branchId: Yup.string().required(t("required")),
    bankId: Yup.string().required(t("required")),
    bankGroupId: Yup.string().required(t("required")),
    claims: Yup.array().min(1, t("required")).nullable(),
    gender: Yup.string().required(t("required")),
    consultantHelperName: Yup.string().nullable(),
  });
  let totalClaims = [];
  const getAllActiveClaims = (list) => {
    list?.forEach((child) => {
      if (child.value) totalClaims.push(child.claimId);
      if (child.hasOwnProperty("sub")) getAllActiveClaims(child.sub);
    });
  };

  const handleSubmit = async (values, { resetForm }) => {
    let obj = {
      firstName: values.firstName,
      lastName: values.lastName,
      active: values.isActive,
      consultantId: values.consultantId || "",
      gender: values.gender,
      claims: [],
    };
    if (values.consultantHelperName != null) {
      obj.consultantHelperName = values.consultantHelperName;
    }
    getAllActiveClaims(permissionsList);

    obj.claims = [...totalClaims];

    setButtonLoading(true);
    let result = await UpdateUserById(userIdParam, obj);
    console.log('resultresult', result)
    if (result?.success) {
      setButtonLoading(false);
      navigate(`/user-management/detail/${userIdParam}`);
    } else if (result.status === 403) {
      toast.error(t(result?.data?.message));
      setButtonLoading(false);
    } else if (result.status === 422) {
      console.log('result.message', result)
      if (result?.data?.message === "You don't have permission to access this resource") {
        toast.error(t('no-permission-message'));
      } else if (result?.data.message === "Please select product permission") {
        toast.error(t('no-product-permission-message'));
      }
      setButtonLoading(false);
    } else {
      toast.error(t(result?.data?.message.replaceAll(" ", "-")));
      setButtonLoading(false);
    }
    setButtonLoading(false);

  };

  const handleStepError = (stepId, isError) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isError = isError;
        }
        return step;
      });
      return updatedSteps;
    });
  };

  const handleStepCompletion = (stepId, isCompleted) => {
    setSwiperSteps((prev) => {
      const updatedSteps = prev.map((step) => {
        if (step.id === stepId) {
          step.isCompleted = isCompleted;
        }
        return step;
      });
      return updatedSteps;
    });
  };
  const handleNext = () => {
    setCurrentTab((pre) => pre + 1);
  };
  const handleBack = () => {
    setCurrentTab((pre) => pre - 1);
  };
  const handleJump = (tabId) => {
    setCurrentTab(tabId);
  };

  ////----------------- Effects

  const getUserDetails = async () => {
    let result = await getUserById(userIdParam);
    if (result?.success) {
      setUserDetails(result?.payLoad);
      const { branchId, bankId, bankGroupId } =
        result?.payLoad.branchInfo || {};
      setBankGroupId(bankGroupId);
      setBankId(bankId);
      setBranchId(branchId);
      let pathIds = {
        branchId,
        bankId,
        bankgroupsId: bankGroupId,
      };
      const response = await getBranchProducts(pathIds);
      if (response.success) {
        return setBranchProducts(
          response.payLoad.filter((product) => product.assigned === "Active")
        );
      } else {
      }
    }
  };

  const getRoles = async () => {
    let resultRoles = await getAllowedUsers();
    if (resultRoles?.success) {
      setRolesList(resultRoles?.payLoad);
    }
  };

  const getActiveUserPermissions = (claims, permissions) => {
    permissions.forEach((permission) => {
      if (claims.includes(permission.claimKey)) permission.value = true;
      if (permission.hasOwnProperty("sub"))
        getActiveUserPermissions(claims, permission.sub);
    });
  };
  const getPermissions = async (value = "") => {
    let resultPermissions = await getUserPermissions();
    if (resultPermissions?.success) {
      let rawPermissions = [...resultPermissions.payLoad];
      if (
        userDetails?.role?.roleName == "#EC" ||
        userDetails?.role?.roleName == "#EU"
      ) {
        rawPermissions = rawPermissions.filter(
          (item) =>
            item.applicationKey == null ||
            item.applicationKey === "#VdsManagement" ||
            (value && value.includes(item.applicationKey)) ||
            (userDetails?.applicationKeys.length > 0 &&
              userDetails.applicationKeys.includes(item.applicationKey)) ||
            (userDetails.applicationKeys.includes("#Gecco") &&
              ["#Esg"].includes(item.applicationKey))
        );
      }
      if (JSON.parse(localStorage.getItem("userRole"))?.roleName == "#EC") {
        rawPermissions = rawPermissions.filter(
          (item) =>
            item.applicationKey == null ||
            item.applicationKey === "#VdsManagement" ||
            JSON.parse(localStorage.getItem("applicationKeys")).includes(
              item.applicationKey
            )
        );
      }
      let formatedPermissions = formatPermissions(rawPermissions);

      setPermissionsListBackup(formatedPermissions);
      formatedPermissions = formatedPermissions.filter(
        (item) => item.type === userDetails.role?.roleName
      );
      let activeClaims = userDetails.claims.map((claim) => claim.claimKey);

      getActiveUserPermissions(activeClaims, formatedPermissions);
      setPermissionsList([...formatedPermissions]);
    }
  };

  const getBankList = async () => {
    let result = await getAllBankslist(bankGroupId);
    if (result?.success) {
      setBankList(result.payLoad);
    }
  };

  const getBranchNameList = async (bankId) => {
    const pathIds = { bankgroupsId: bankGroupId, bankId: bankId };
    let result = await getBranchNames(pathIds);
    if (result?.success) {
      setBranchNameList(result?.payLoad);
    }
  };

  const getConsultantList = async () => {
    const CONSULTANT_ROLE_KEY = "%23EC";
    let params = {
      role: CONSULTANT_ROLE_KEY,
      bankId,
      branchId,
      applicationKeys: userDetails.applicationKeys,
    };
    const result = await getConsultantUsers(params);
    setConsultantList(result?.payLoad?.items);
  };
  useEffect(() => {
    getUserDetails();
    getRoles();
    getBankList();
  }, []);
  useEffect(() => {
    Object.values(userDetails).length > 0 && getPermissions();
  }, [userDetails, branchProducts]);
  useEffect(() => {
    Object.values(userDetails).length > 0 &&
      permissionsListBackup.length > 0 &&
      (() => {
        setShowForm(true);
        setInitialValues({
          email: userDetails.email,
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          roleId: userDetails?.role?.roleName,
          bankGroupId: userDetails.branchInfo?.bankGroupId,
          bankId: userDetails.branchInfo?.bankId,
          branchId: userDetails.branchInfo?.branchId,
          consultantId: userDetails?.consultantId?.toLowerCase(),
          consultantProduct:
            //userDetails?.applicationKeys.length &&
            userDetails?.applicationKeys.find(
              (x) => x === "#Gecco" || x === "#FutureCare"
            ),
          isActive: userDetails.isActive,
          claims: [...permissionsList],
          gender: userDetails.gender,
          consultantHelperName: userDetails.consultantHelperName,
        });
      })();
  }, [permissionsList]);

  useEffect(() => {
    bankId && getBranchNameList(bankId);
  }, [bankId]);
  useEffect(() => {
    branchId && getConsultantList();
  }, [branchId]);
  const handleChangeRole = (item) => {
    let newPermissions = permissionsListBackup.filter(
      (el) => el.type === item.name && el.parentId === null
    );
    setPermissionsList(newPermissions);
  };

  const handleChangeClaims = (event, item) => {
    let list = handleClaimsParentLevel(event, item, permissionsList);

    setPermissionsList([...list]);
    setInitialValues({ ...initialValues, claims: [...list] });
  };

  const renderTab = (formik) => {
    if (currentTab === 1) {
      return (
        <RoleInfo
          formik={formik}
          bankGroupList={bankGroupList}
          bankList={bankList}
          setBankId={setBankId}
          branchNameList={branchNameList}
          setBranchId={setBranchId}
          next={handleNext}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    }
    if (currentTab === 2) {
      return (
        <GeneralInfo
          formik={formik}
          roles={
            location?.hash === "#AU"
              ? rolesList?.filter((item) => item.name === "#AU")
              : rolesList?.filter((item) => item.name !== "#AU")
          }
          consultantList={consultantList}
          handleChangeRole={handleChangeRole}
          next={handleNext}
          back={handleBack}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
          getPermissions={getPermissions}
          branchProducts={branchProducts}
        />
      );
    }
    if (currentTab === 3) {
      return (
        <ClaimsInfo
          formik={formik}
          handleChangeClaims={handleChangeClaims}
          permissions={permissionsList}
          loading={buttonLoading}
          back={handleBack}
          handleCompletion={handleStepCompletion}
          handleError={handleStepError}
        />
      );
    }
  };

  return (
    <>
      <Toaster />
      <Container className="p-md-5 py-xxs-5 px-xxs-2">
        <div className="custom-breadcrumbs ">
          <span
            className="breadcrumbs-item "
            onClick={() => {
              navigate("/user-management");
            }}
          >
            {t("user-management")}
          </span>
          <span className="breadcrumbs-item ">{t("update-user")}</span>
        </div>
        <div className="d-flex justify-content-center">
          <div className="shadow bg-body w-50 pt-3 pb-5 rounded">
            {showForm ? (
              <Formik
                initialValues={initialValues}
                validationSchema={validate}
                onSubmit={(values, { resetForm }) => {
                  handleSubmit(values, resetForm);
                }}
              >
                {(formik) => {
                  return (
                    <>
                      <SwiperSteps
                        list={swiperSteps}
                        tab={currentTab}
                        maxWidthSwiper={true}
                        back={handleBack}
                        next={handleNext}
                        jump={handleJump}
                      />
                      <Form>
                        <div className="px-5 py-2 ">{renderTab(formik)}</div>
                      </Form>
                    </>
                  );
                }}
              </Formik>
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default EditUser;
